var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-full detail-w mx-auto pt-20px"},[_c('div',{staticClass:"mt-30px"},[_c('div',{staticClass:"ql-container ql-snow"},[_c('div',{staticClass:"ql-editor",domProps:{"innerHTML":_vm._s(_vm.detailInfo.content)}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }